import React, { Component } from "react";
import { debounce } from "underscore";

import { css } from "aphrodite/no-important";
import style from "./style";
import { pageView } from "../utils/analytics";

import Content from "../store/index";
import components from "../components/library/index";
import heroImg from "../components/Media/hero-image.jpg";
import ubLogo from "../assets/UB-logo.png";
import IntroText from "../components/IntroText";
import Media from "../components/Media";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";

class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      timer: null,
      desktop: null,
    };
  }

  componentWillMount() {
    this.setDesktopWidth();
  }

  componentDidMount() {
    pageView();
    window.addEventListener("resize", this.resize, false);
    window.addEventListener("DOMContentLoaded", () => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const id = entry.target.getAttribute("id");
          if (entry.intersectionRatio > 0) {
            const element = document.querySelector(`ul li a[href="#${id}"]`);
            if (element !== null) {
              element.classList.add(css(style.active));
              element.parentElement.classList.add(css(style.activeLi));
            }
          } else {
            const element = document.querySelector(`ul li a[href="#${id}"]`);
            if (element !== null) {
              element.classList.remove(css(style.active));
              element.parentElement.classList.remove(css(style.activeLi));
            }
          }
        });
      });

      // Track all sections that have an `id` applied
      document.querySelectorAll("section[id]").forEach((section) => {
        observer.observe(section);
      });
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize, false);
  }

  getActiveMedia(id) {
    this.setState({ activeMedia: id });
  }

  setDesktopWidth = () =>
    this.setState(() => ({ desktop: window.innerWidth >= 1024 }));
  resize = debounce(this.setDesktopWidth, 500);

  render() {
    const { isMediaComponent, desktop } = this.state;

    return (
      <div>
        <div className={css(style.heroContainer)}>
          <Media paddingTop="55%" type="img" src={heroImg} noMargin />

          <div className={css(style.header_gradient)} />

          <img
            className={css(style.logoContainer)}
            src={ubLogo}
            alt="Underbelly Logo"
          />
          <IntroText />
        </div>

        <div className={css(style.main)}>
          {desktop && (
            <Navigation
              Content={Content}
              isMediaComponent={isMediaComponent}
            />
          )}

          <div className={css(style.appContainer)}>
            {Content.map(({ id, section, items }) => {
              return (
                <section id={section} style={{marginBottom: '2px'}}>
                  {items.map(({id, type, content}) => {
                    if (type === "Media" || type === "MediaSplit") {
                        return React.createElement(components[type], {
                          key: id,
                          id,
                          ...content,
                        });
                      }
                      return (
                        <div
                          className={css(style.project)}
                          id={id}
                          key={id}
                        >
                          {React.createElement(components[type], {
                            key: id,
                            ...content,
                          })}
                        </div>);
                  })}

                </section>
              );
            })}
          </div>
        </div>
        <div className={css(style.footerSpacer)} />
        <Footer />
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/views/index.js